export const API_URL = process.env.REACT_APP_API_BASE_URL;
export const IMAGE_HOST = process.env.REACT_APP_IMAGE_HOST;
